import { render } from "./AddMeldingContactgegevensView.vue?vue&type=template&id=8949d35e&scoped=true"
import script from "./AddMeldingContactgegevensView.vue?vue&type=script&lang=js"
export * from "./AddMeldingContactgegevensView.vue?vue&type=script&lang=js"

import "./AddMeldingContactgegevensView.vue?vue&type=style&index=0&id=8949d35e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8949d35e"]])

export default __exports__